import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AppService } from '../../services/app.service';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss'
})
export class BannerComponent implements OnInit, OnDestroy {
  assetsUrl: string = '';
  private $appData: Subscription;
  data: any = {};
  bgClass: string = 'banner';

  constructor(appService: AppService, private apiService: ApiService) {
    this.assetsUrl = appService.ENV.ASSETS_BASE_URL;
    this.$appData = this.apiService.$appData.subscribe((data: any) => { this.data = data });
  }

  ngOnInit() {
    var data = this.apiService.getData();
    this.data = data;
    this.setBgClass();
    window.addEventListener('resize', this.setBgClass.bind(this));
  }

  ngOnDestroy(): void {
    this.$appData.unsubscribe();
    window.removeEventListener('resize', this.setBgClass.bind(this));
  }

  setBgClass() {
    // Date logic: before Nov 1, 2025 midnight use bg.jpg, after use bg2.jpg
    const now = new Date();
    const nov1 = new Date('2025-11-01T00:00:00');
    const isAfterNov1 = now >= nov1;
    // Screen size logic: match the same as your SCSS media query (tablet breakpoint)
    const isTablet = window.matchMedia('(max-width: 800px)').matches;
    if (isTablet) {
      this.bgClass = isAfterNov1 ? 'banner bg2-mobile' : 'banner bg-mobile';
    } else {
      this.bgClass = isAfterNov1 ? 'banner bg2' : 'banner bg';
    }

  }
}
